/** @format */

import WasmController from "react-lib/frameworks/WasmController";

import { History } from "history";
import moment, { ISO_8601 } from "moment";
import Cookies from "js-cookie";

// APIs
import FastAPIRequestView from "issara-sdk/apis/FastAPIRequestViewM";

import * as MobInsuranceI from "./MobInsuranceInterface";
import * as SelectHospitalI from "./appointment/SelectHospitalInterface";
import * as SmartAppointmentI from "./MobSmartAppointmentInterface";
// profile
import ProxyMyProfile from "issara-sdk/apis/ProxyMyProfile_profileM";
import UserPermissionView from "issara-sdk/apis/UserPermissionView_users";

// Utils

// Config

// Types
import {
  DocumentDetail,
  EstimatorType,
  InsuranceListType,
  INSURANCE_URLS,
  PackageType,
  PolicyStatusType,
  UIPolicy,
  InsuranceDataFormatType,
  InsuranceDataSubmissionsType,
  ImageFromNativeType,
  MenuItemStatusType,
  MenuItemStatusSelectedType,
} from "./insurance/InsuranceType";
import { setUserId } from "firebase/analytics";
import BaseService from "react-lib/apis/services/BaseService";
import config from "config/config";
import { to } from "react-lib/utils";
import V3AppointmentView from "issara-sdk/apis/V3AppointmentView_apps_PRX";
import ProxyOrganizationSerializer from "issara-sdk/types/ProxyOrganizationSerializer_apps_PRX";
import ProxyOrganizationView from "issara-sdk/apis/ProxyOrganizationView_apps_PRX";
import SmartInsuranceSendMail from "issara-sdk/apis/SmartInsuranceSendMail_apps_PRX";

type InsuranceItem = {
  insurance_code: string;
  insurance_type: string[];
  [key: string]: any;
};

export type State = Partial<{
  loggedin: boolean;
  platform: string;
  theme: string;
  projectName: string;
  device_id: string | number;
  subscription: any;
  apiToken: string;
  userId: string | number;
  permit: string;
  language: "en-US" | "th-TH";
  channelId: string | number;
  isVerified: boolean;
  consentREF?: string;
  verifiedStatus: boolean;
  safeAreaTop?: string;
  isExcessListFirsTime: boolean;
  storeURL: string;
  // Common
  patientDetail: any;

  // message
  loadingStatus: Record<string, any>;
  errorMessage: Record<string, any>;
  successMessage: Record<string, any>;

  claimListData: any[];
  notiPendingInsurance: any[];
  packageListData: any[];
  excessClaimData: any[];
  oopPolicyList: PolicyStatusType[];
  transformedPolicies: UIPolicy[];
  oopPolicySelected: PolicyStatusType[];
  selectedClaim: any;
  documentDetail?: DocumentDetail;
  estimatorData?: EstimatorType[];
  insuranceList?: InsuranceListType[];
  cardInsuranceList?: InsuranceDataFormatType[];
  appointmentSelected?: Record<string, any>;
  submissionsList?: InsuranceDataFormatType[];
  preverUiMode?: "unknow" | "status" | "irlist";
  submitStatus?: string;
  itemDetail?: InsuranceDataFormatType;
  imageFromNative?: ImageFromNativeType;
  preVerificationStatusDetail?: Record<string, any>;
  menuItemStatus?: MenuItemStatusType[];
  menuItemStatusSelected: MenuItemStatusSelectedType | undefined;
  organizationDetail: ProxyOrganizationSerializer & {};
}> &
  SelectHospitalI.State;

export const StateInitial: State = {
  language: ["th", "th-TH", "th-th"].includes(
    Cookies.get("language") || navigator?.language?.split(/[-_]/)[0],
  )
    ? "th-TH"
    : "en-US",
  loadingStatus: {},
  errorMessage: {},
  successMessage: {},
  patientDetail: [],
  claimListData: [],
  notiPendingInsurance: [],
  packageListData: [],
  excessClaimData: [],
  oopPolicyList: [],
  transformedPolicies: [],
  oopPolicySelected: [],
  selectedClaim: {},
  isVerified: false,
  isExcessListFirsTime: true,
  consentREF: "",
  storeURL: "",
  safeAreaTop: undefined,
  insuranceList: [],
  cardInsuranceList: [],
  appointmentSelected: {},
  submissionsList: [],
  preverUiMode: "unknow",
  submitStatus: undefined,
  itemDetail: undefined,
  preVerificationStatusDetail: undefined,
  imageFromNative: undefined,
  menuItemStatus: [],
  menuItemStatusSelected: undefined,
  ...SelectHospitalI.StateInitial,
  ...SmartAppointmentI.StateInitial.myAppointmentList,
};

export type Event =
  // Native
  | { message: "handleClearMessage"; params: {} }
  | { message: "GetLoginInfo"; params: {} }
  | { message: "HandleSetOpenBurger"; params: {} }
  | { message: "HandleBacktoNative"; params: {} }
  | { message: "GetMyProfileDetail"; params: {} }
  | {
      message: "HandleGetDetail";
      params: {
        consentRefId: string;
        card: string;
        history: any;
        title: string;
      };
    }
  | { message: "DidMount"; params: {} }
  | { message: "DidUpdate"; params: {} }
  | {
      message: "HandleGetVerifyConsent";
      params: { consentRefId: string; consentFlag: boolean; card: string };
    }
  | { message: "HandleGetClaimList"; params: {} }
  | { message: "HandleGetUnreadNoti"; params: {} }
  | { message: "HandleGetPackageList"; params: {} }
  | { message: "HandleGetExcessClaimList"; params: {} }
  | { message: "HandleGetPolicyListOOP"; params: {} }
  | { message: "HandleAddExcessClaimList"; params: {} }
  | { message: "SelectedClaim"; params: { card: string; item: any } }
  | {
      message: "HandleVerifyPackage";
      params: { package: PackageType; card: string };
    }
  | {
      message: "HandleGetInsuranceList";
      params: { card: string };
    }
  | {
      message: "HandleSetInsuranceDetail";
      params: { id: string; key: string; value: any; subKey?: string };
    }
  | {
      message: "HandleNewCardInsurance";
      params: { card: string; insuranceItem: any };
    }
  | {
      message: "HandleGetLastVisit";
      params: { card: string; enableIMS: boolean };
    }
  | {
      message: "HandleSubmissionForm";
      params: { card: string; signatureBase64: string; isEnableIMS: boolean };
    }
  | {
      message: "HandleGetPerVerificationStatus";
      params: { card: string; docId: string; en: string };
    }
  | {
      message: "HandleInsuranceDuplicate";
      params: { card: string; mainId: string; secondId: string };
    }
  | {
      message: "HandleInsuranceCheckEmptyFill";
      params: { card: string; id: string };
    }
  | {
      message: "HandleGetStatusMenu";
      params: { card: string };
    }
  | {
      message: "HandleCancelSubmit";
      params: {
        card: string;
        en: string;
        docId: string;
        reason: string;
        reasonCode: string;
      };
    }
  | { message: "GetOrganizationDetail"; params: {} }
  | SelectHospitalI.Event
  | SmartAppointmentI.Event;

export type Data = {};

export const DataInitial = {};

const searchParams = new URLSearchParams(window.location.search);
const app = searchParams.get("app");

type Handler<P = any, R = any> = (
  controller: WasmController<State, Event, Data>,
  params: P,
) => R;

type Params<A extends Event["message"]> = Extract<
  Event,
  { message: A }
>["params"];

export const handleClearMessage: Handler = (controller) => {
  controller.setState({ errorMessage: {}, successMessage: {} });
};

export const DidMount: Handler = async (controller, params) => {
  console.log("MobPayment DidMount: ");

  let userId = controller.cookies.get("userId");
  let apiToken = controller.cookies.get("apiToken");
  let permit = controller.cookies.get("permit");

  if (!controller.apiToken && apiToken) {
    controller.apiToken = apiToken;
  }

  if (!controller.user && userId) {
    controller.user = userId;
  }

  if (!controller.permit && permit) {
    controller.permit = permit;
    controller.cookies.set("bearer", permit);
  }

  // for test
  // controller.setState({
  //   estimatorData: mockEstimator
  // })

  SelectHospitalI.SelectedInitialHospital(controller, params);
};

export const DidUpdate: Handler = async (controller, params) => {
  //
};

export const HandleSetInsuranceDetail: Handler = (controller, params) => {
  const { cardInsuranceList } = controller.getState();
  const { id, key, value, subKey } = params;
  const newList = [...cardInsuranceList];

  const index = newList.findIndex((item) => item.id === id);

  // common case สำหรับ update field ต่างๆใน card insurance ที่มีอยู่แล้ว
  if (index === -1) return;
  const updatedItem = { ...newList[index] };

  if (subKey) {
    if (subKey) {
      updatedItem[key] = updatedItem[key] ?? {};
      updatedItem[key][subKey] = updatedItem[key][subKey] ?? "";
      updatedItem[key][subKey] = value;
    }
  } else {
    updatedItem[key] = value;
  }

  // case confirm  new card
  if (key === "id") {
    updatedItem["isActive"] = true;
    if (!updatedItem["dataSubmissions"]["claim_type"]) {
      updatedItem["dataSubmissions"]["claim_type"] =
        updatedItem["dataSubmissions"]["claim_group"];
    }
    updatedItem["cardSelected"] = true;
  }

  // case expand card insurance ถ้า expand จะถือว่าเลือก card นั้น
  // ถ้าเลือก card insurance จะถือว่า expand card นั้น
  if (
    (key === "expand" && !updatedItem["cardSelected"]) ||
    (key === "cardSelected" && value)
  ) {
    updatedItem["expand"] = value;
    updatedItem["cardSelected"] = value;
  }
  newList[index] = updatedItem;

  controller.setState({
    cardInsuranceList: newList,
    ...(key === "insurance_card_copy" && { imageFromNative: undefined }),
  });
};

export const HandleInsuranceDuplicate: Handler = (controller, params) => {
  const state = controller.getState();

  const mainCard: InsuranceDataFormatType = (
    state.cardInsuranceList || []
  ).find(
    (item: InsuranceDataFormatType) => item.id === params.mainId,
  )?.dataSubmissions;

  const newList = [...state.cardInsuranceList];

  const index = newList.findIndex((item) => item.id === params.secondId);

  if (index === -1) return;
  const updatedItem = { ...newList[index] };
  const insuranceSecondCard = updatedItem.insuranceSelected;

  if (
    (insuranceSecondCard.insured_types || []).some(
      (item: any) => item.value === mainCard.insured_type_name,
    )
  ) {
    updatedItem["dataSubmissions"]["insured_type_name"] =
      mainCard.insured_type_name;
  }

  if (
    (insuranceSecondCard.claim_groups || []).some(
      (item: any) => item.value === mainCard.claim_group,
    )
  ) {
    updatedItem["dataSubmissions"]["claim_group"] = mainCard.claim_group;
    if (
      !mainCard.claim_group
        ?.toLocaleLowerCase()
        .includes("HEALTH_CHECKUP".toLocaleLowerCase())
    ) {
      updatedItem["dataSubmissions"]["symptoms"] = mainCard.symptoms;
    }
    if (
      (mainCard?.claim_group || "")
        ?.toLocaleLowerCase()
        .includes("ACCIDENT".toLocaleLowerCase())
    ) {
      if (
        (insuranceSecondCard.claim_types || []).some(
          (item: any) => item.value === mainCard.claim_type,
        )
      ) {
        updatedItem["dataSubmissions"]["claim_type"] = mainCard.claim_type;
      }
      updatedItem["dataSubmissions"]["accident_datetime"] =
        mainCard.accident_datetime;
    }
  }

  const group =
    updatedItem.dataSubmissions?.claim_group?.toLocaleLowerCase() || "";
  const data = updatedItem.dataSubmissions || {};
  // เก็บ field ที่จะตรวจ
  let fieldsToCheck: string[] = [];

  if (group.includes("accident".toLocaleLowerCase())) {
    fieldsToCheck = [
      "claim_type",
      "insured_type_name",
      "claim_group",
      "accident_datetime",
      "symptoms",
    ];
  } else if (group.includes("health_checkup".toLocaleLowerCase())) {
    fieldsToCheck = ["insured_type_name", "claim_group"];
  } else {
    fieldsToCheck = ["insured_type_name", "claim_group", "symptoms"];
  }

  // ตรวจแต่ละ field ว่าเป็นค่าว่างไหม
  const emptyFields = fieldsToCheck.filter((key) => data[key] === "");

  updatedItem["emptyField"] = emptyFields;
  updatedItem["cardSelected"] = emptyFields.length > 0 ? false : true;
  updatedItem["expand"] = true;
  newList[index] = updatedItem;
  controller.setState({
    cardInsuranceList: newList,
  });
};

export const HandleInsuranceCheckEmptyFill: Handler = (controller, params) => {
  const state = controller.getState();
  const newList = [...state.cardInsuranceList];

  const index = newList.findIndex((item) => item.id === params.id);

  if (index === -1) return;
  const updatedItem = { ...newList[index] };
  const group =
    updatedItem.dataSubmissions?.claim_group?.toLocaleLowerCase() || "";
  const data = updatedItem.dataSubmissions || {};

  // เก็บ field ที่จะตรวจ
  let fieldsToCheck: string[] = [];

  if (group.includes("accident".toLocaleLowerCase())) {
    fieldsToCheck = [
      "claim_type",
      "insured_type_name",
      "claim_group",
      "accident_datetime",
      "symptoms",
    ];
  } else if (group.includes("health_checkup".toLocaleLowerCase())) {
    fieldsToCheck = ["insured_type_name", "claim_group"];
  } else {
    fieldsToCheck = ["insured_type_name", "claim_group", "symptoms"];
  }

  // ตรวจแต่ละ field ว่าเป็นค่าว่างไหม
  const emptyFields = fieldsToCheck.filter((key) => data[key] === "");

  updatedItem["emptyField"] = emptyFields;
  updatedItem["expand"] = true;
  newList[index] = updatedItem;

  controller.setState({
    cardInsuranceList: newList,
  });
};

export const HandleGetClaimList: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  const [result] = await FastAPIRequestView.get({
    bearer: controller.cookies.get("bearer"),
    endpoint: "/insurance/list_claim_status/",
  });

  controller.setState({
    claimListData: result || [],
    ...(params.consentREF && {
      selectedClaim: (result || []).find(
        (item: any) => item.ref_id === params.consentREF,
      ),
    }),
    loadingStatus: { ...state.loadingStatus, [params.card]: false },
  });
};

export const HandleGetUnreadNoti: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  const [response, error, network] = await FastAPIRequestView.get({
    bearer: controller.cookies.get("bearer"),
    endpoint: "/insurance/list_unread_noti/",
  });

  if (error) {
    state = controller.getState();
    controller.setState({
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  } else {
    state = controller.getState();
    controller.setState({
      notiPendingInsurance: response?.data || [],
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  }
};

export const HandleAddExcessClaimList: Handler = async (controller, params) => {
  let state = controller.getState();

  console.log(params);

  let tmpResult: any[] = [];

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  for (const field of params?.inputFields) {
    const value = field.value;

    try {
      const [response, error, network] = await FastAPIRequestView.post({
        // bearer: controller.cookies.get("bearer"),
        token: controller.cookies.get("apiToken"),
        endpoint: "/insurance/patient/check-eligible",
        data: {
          bu_code: state.selectedHospital?.code,
          hn: state.selectedHospital?.hn,
          id_type: "POLICY_NUMBER",
          id: value,
        },
      });

      console.log("result...", response);
      console.log("error...", error);
      console.log("network...", network);

      tmpResult.push({ value, response, error });

      console.log("API result for value:", value, response);
    } catch (error) {
      console.error("Error calling API for value:", value, error);
    }
  }

  controller.setState({
    excessClaimData: tmpResult,
    loadingStatus: { ...state.loadingStatus, [params.card]: false },
  });

  HandleGetPolicyListOOP(controller, params); // refresh list
};

export const HandleGetExcessClaimList: Handler = async (controller, params) => {
  let state = controller.getState();

  if (!params.inBackground) {
    controller.setState({
      loadingStatus: { ...state.loadingStatus, [params.card]: true },
    });
  }

  console.log("HandleGetExcessClaimList ", state.selectedHospital);

  const [result] = await FastAPIRequestView.post({
    // bearer: controller.cookies.get("bearer"),
    token: controller.cookies.get("apiToken"),
    endpoint: "/insurance/patient/check-eligible",
    data: {
      bu_code: state.selectedHospital?.code,
      hn: state.selectedHospital?.hn,
      id_type: "NATIONAL_ID",
    },
  });

  if (!params.inBackground) {
    controller.setState({
      // excessClaimData: result || {},
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  }

  HandleGetPolicyListOOP(controller, params); // refresh list
};

export const transformPolicyList = (
  responses: PolicyStatusType[],
): UIPolicy[] => {
  const policies: UIPolicy[] = [];

  responses.forEach((response) => {
    const data = response;

    // Add main policy from customerDetail
    // policies.push({
    //   identityType: data.identityType,
    //   policyNo: data.customerDetail?.policyNo,
    //   policyDescription: data.customerDetail?.policyDescription,
    //   refid: data.refid
    // });

    // Filter coverageList for type "HS" and status true
    const eligibleCoverages = data.coverageList?.filter(
      (coverage: any) => coverage.type === "HS" && coverage.status === true,
    );

    // Add additional policies from filtered coverageList
    eligibleCoverages.forEach((coverage: any) => {
      // Filter messageList for PASS status only
      const eligibleMessages = coverage.messageList.filter(
        (msg: any) => msg.ruleNo === "PASS",
      );

      // Filter out NOT_PASS messages, allow all other ruleNo values
      // const eligibleMessages = coverage.messageList.filter(msg => msg.ruleNo !== "NOT_PASS");

      eligibleMessages.forEach((msg: any) => {
        // Only add if it's a new policy number and not the main one
        const existingPolicy = policies.find(
          (p) => p.policyNo === msg.policyNo,
        );
        if (!existingPolicy) {
          policies.push({
            identityType: data.identityType,
            policyNo: msg.policyNo,
            policyDescription:
              msg.planName || data.customerDetail?.policyDescription,
            refid: data.refid,
          });
        }
      });
    });
  });

  return policies;
};

export const HandleGetPolicyListOOP: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    transformedPolicies: [], // Add this for workaround fix recyclerview
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  const [result] = await FastAPIRequestView.get({
    // bearer: controller.cookies.get("bearer"),
    token: controller.cookies.get("apiToken"),
    endpoint: "/insurance/list_oop_policy_status/",
  });

  const transformedPolicies = transformPolicyList(result || []);
  console.log("transformedPolicies", transformedPolicies);

  controller.setState({
    transformedPolicies: transformedPolicies || [],
    loadingStatus: { ...state.loadingStatus, [params.card]: false },
  });
};

export const HandleGetDetail: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  const [result] = await FastAPIRequestView.get({
    bearer: controller.cookies.get("bearer"),
    endpoint: `/insurance/claim-info/document/${params.consentRefId}`,
  });

  if (result?.data) {
    controller.setState({
      documentDetail: result.data || {},
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
    let url =
      INSURANCE_URLS.INSURANCE_PDF + "/?app=MobInsurance&title=" + params.title;
    params.history.push(url);
  } else {
    controller.setState({
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });

    // params.history.push("/insurance-pdf/?app=MobInsurance");
  }
};

export const HandleGetPackageList: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  console.log("selectedHospital", state.selectedHospital);

  const [result, error, network] = await FastAPIRequestView.post({
    bearer: controller.cookies.get("bearer"),
    endpoint: "/insurance/patient/package-list",
    data: {
      bu_code: state.selectedHospital?.code,
      hn: state.selectedHospital?.hn,
    },
  });

  if (result?.data) {
    controller.setState({
      packageListData: result.data || [],
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  } else if (error) {
    controller.setState({
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
      errorMessage: error,
    });
  } else {
    controller.setState({
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  }
};

export const HandleGetVerifyConsent: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  let route = false;
  if (params.count) {
    for (var i = 0; i < params.count; i++) {
      const [result] = await FastAPIRequestView.post({
        bearer: controller.cookies.get("bearer"),
        endpoint: "/insurance/patient/consent",
        data: {
          ref_id: params.consentRefId,
          consent_flag: params.consentFlag,
        },
      });
      if (result?.routed) {
        route = true;
      }
    }
  } else {
    const [result] = await FastAPIRequestView.post({
      bearer: controller.cookies.get("bearer"),
      endpoint: "/insurance/patient/consent",
      data: {
        ref_id: params.consentRefId,
        consent_flag: params.consentFlag,
      },
    });
    if (result?.routed) {
      route = true;
    }
  }

  const [result2] = await FastAPIRequestView.post({
    bearer: controller.cookies.get("bearer"),
    endpoint: `/insurance/mark_noti_as_read/${params.consentRefId}`,
    data: {},
  });

  if (route) {
    const [resList] = await FastAPIRequestView.get({
      bearer: controller.cookies.get("bearer"),
      endpoint: "/insurance/list_claim_status/",
    });
    const selected = resList.filter(
      (item: any) => item.ref_id === params.consentRefId,
    );

    if (selected?.[0]) {
      controller.setState({
        verifiedStatus: params.consentFlag,
        selectedClaim: selected?.[0] || {},
        loadingStatus: { ...state.loadingStatus, [params.card]: false },
        notiPendingInsurance: state.notiPendingInsurance?.filter(
          (noti: any) => noti.payload.ref_id !== params.consentRefId,
        ),
      });
    } else {
      controller.setState({
        loadingStatus: { ...state.loadingStatus, [params.card]: false },
        notiPendingInsurance: state.notiPendingInsurance?.filter(
          (noti: any) => noti.payload.ref_id !== params.consentRefId,
        ),
      });
    }
  } else {
    controller.setState({
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
      notiPendingInsurance: state.notiPendingInsurance?.filter(
        (noti: any) => noti.payload.ref_id !== params.consentRefId,
      ),
    });
  }
};

export const GetMyProfileDetail: Handler = async (controller, params) => {
  const [res] = await ProxyMyProfile.get({
    apiToken: controller.cookies.get("apiToken"),
  });

  let userId = controller.cookies.get("userId");

  setUserId(
    controller.analytics,
    userId !== undefined || userId !== "" ? userId : "0",
  );

  controller.setState({ patientDetail: res || {} });
};

export const HandleVerifyPackage: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  const promiseArr = (state.oopPolicySelected || [])?.map(
    (item: PolicyStatusType) => {
      return FastAPIRequestView.post({
        bearer: controller.cookies.get("bearer"),
        endpoint: "/insurance/patient/cost-estimator",
        data: {
          package_code: params.package.packageCode,
          policy_type: "IB",
          bu_code: state.selectedHospital?.code,
          hn: state.selectedHospital?.hn,
          ref_id: item.refid,
        },
      });
    },
  );

  const response = await Promise.all(promiseArr);

  const success = response.every((res) => res[0]?.Data?.RefId);
  const errors = response.map((res) => res[1]);

  console.log("errors", errors);

  if (success && response.length > 0) {
    const estimatorList = response.map((itemEst) => {
      const policyStatus = state.oopPolicySelected?.find(
        (items) => items.refid === itemEst[0].Data.RefId,
      );
      return { ...itemEst[0], package: params.package, policy: policyStatus };
    });

    controller.setState({
      verifiedStatus: true,
      estimatorData: estimatorList,
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  } else if (errors) {
    controller.setState({
      verifiedStatus: false,
      errorMessage: errors[0],
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  } else {
    controller.setState({
      verifiedStatus: false,
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  }
};

export const SelectedClaim: Handler = async (controller, params) => {
  controller.setState({
    selectedClaim: params.item || {},
  });

  let state = controller.getState();

  const ref_id = params.item?.ref_id;
  const history = params.item?.history;
  const last_history = history[history.length - 1];
  const last_status = last_history?.claim_status;

  if (ref_id && last_status !== "Pending") {
    // Check if ref_id exists in notiPendingInsurance

    const notiExists = (state.notiPendingInsurance || []).some(
      (noti: any) => noti.payload.ref_id === ref_id,
    );

    // Call mark_noti_as_read only if ref_id exists in notiPendingInsurance
    if (notiExists) {
      const [result] = await FastAPIRequestView.post({
        bearer: controller.cookies.get("bearer"),
        endpoint: `/insurance/mark_noti_as_read/${ref_id}`,
        data: {},
      });

      // Remove the item with the matching ref_id from notiPendingInsurance
      controller.setState({
        notiPendingInsurance: state.notiPendingInsurance?.filter(
          (noti: any) => noti.payload.ref_id !== ref_id,
        ),
      });
    }
  }
};

export const HandleGetLastVisit: Handler = async (controller, params) => {
  // preverification Main function

  const dateTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";
  let state = controller.getState();
  const buCode = state.selectedHospital?.code;
  const hn = state.selectedHospital?.hn;
  const today = moment().startOf("day");
  const start = today.clone().subtract(4, "days").startOf("day");
  const end = today.clone().add(3, "days").endOf("day");

  controller.setState({
    preverUiMode: "status",
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  //ถ้าแก้ insurance/submissions มีหลายที่ให้เช็คทั้งหมด

  state = controller.getState();
  const [
    lastVisitRes,
    submissionsRes,
    availableListRes,
    availableListIsBrokerRes,
    appointmentRes,
  ] = await Promise.all([
    FastAPIRequestView.post({
      // bearer: controller.cookies.get("bearer"),
      token: state.apiToken,
      endpoint: "/pre-verification/insurance/last-visit",
      data: {
        episode_type: "opd",
        bu_code: buCode,
        hn: hn,
      },
    }),
    FastAPIRequestView.get({
      token: state.apiToken,
      endpoint: `/pre-verification/insurance/submissions`,
      params: {
        filter_start_dt: start.format(dateTimeFormat),
        filter_end_dt: end.format(dateTimeFormat),
      },
    }),
    FastAPIRequestView.post({
      token: state.apiToken,
      endpoint: "/pre-verification/insurance/available-list",
      data: {
        bu_code: buCode,
        insurance_type: "local_insurance",
        visit_type: "opd",
        is_broker: false,
      },
    }),
    FastAPIRequestView.post({
      token: state.apiToken,
      endpoint: "/pre-verification/insurance/available-list",
      data: {
        bu_code: buCode,
        insurance_type: "local_insurance",
        visit_type: "opd",
        is_broker: true,
      },
    }),
    V3AppointmentView.get({
      apiToken: controller.cookies.get("apiToken"),
      params: {
        hospital: buCode,
        cancel: params.cancel,
        include_arrived: true,
      },
    }),
  ]);

  let lastVisitList: InsuranceDataFormatType[] = [];
  let submissionsList: InsuranceDataFormatType[] = [];
  const filterCancel = (appointmentRes[0]?.items || []).filter(
    (items: any) => !items.canceled_at,
  );

  const appointmentSelected = getDatesWithinNext3Days(filterCancel);

  // availableListAll get มาทั้งหมดเพราะมีโอกาศที่ is_broker จะมีเป็น true || false
  const availableListAll = [
    ...(availableListRes[0]?.data || []),
    ...(availableListIsBrokerRes[0]?.data || []),
  ];
  if (
    (lastVisitRes[0]?.data.length > 0 || submissionsRes[0]?.data.length > 0) &&
    params.enableIMS
  ) {
    const seen = new Set<string>();
    // filter lastVisit ที่ซ้ำกันออก
    const filterDuplicateLastVisit = (lastVisitRes[0]?.data || []).filter(
      (item: any) => {
        const firstType = item.insurance_type_name?.[0] || "";
        const key = `${item.insurance_code}-${firstType}`;

        if (seen.has(key)) return false;
        seen.add(key);

        item.insurance_type = [firstType];
        return true;
      },
    );

    /// HandlePrepareCardData คือ function ที่เตรียมข้อมูลทั้งหมดที่ต้องใช้ในการแสดง card

    [lastVisitList, submissionsList] = await HandlePrepareCardData(controller, {
      lastVisitRes:
        filterDuplicateLastVisit || lastVisitRes[0]?.data || undefined,
      submissionsRes: submissionsRes[0]?.data || undefined,
      availableListRes: availableListAll || [],
      appointment: appointmentSelected,
    });
  }

  const storeCard = state.cardInsuranceList.filter(
    (item: InsuranceDataFormatType) => item.cardType === "newcard",
  );

  const cardLastVisitNoneSubmit = (lastVisitList || []).filter(
    (item: InsuranceDataFormatType) =>
      !(submissionsList || []).some((submitItem: InsuranceDataFormatType) =>
        (submitItem?.dataSubmissions?.remark || "").includes(
          `${item?.dataSubmissions?.remark}-${appointmentSelected[0]?.encounter_number}`,
        ),
      ),
  );

  const findCardCancelHold = (submissionsList || []).filter(
    (item: any) => item.status === "Cancelled_with_hold",
  );
  const enApp = findCardCancelHold?.[0]?.original_payload?.episode_no;
  const appDate = findCardCancelHold?.[0]?.original_payload?.appointment_date;

  state = controller.getState();

  // availableListRes ใช้แค่อันที่ is_broker = false
  controller.setState({
    ...(params.enableIMS && {
      cardInsuranceList: [...submissionsList, ...cardLastVisitNoneSubmit],
    }),
    loadingStatus: { ...state.loadingStatus, [params.card]: false },
    insuranceList: availableListRes[0]?.data || [],
    appointmentSelected: enApp
      ? [
          {
            ...appointmentSelected,
            encounter_number: enApp,
            date: appDate,
            isCanUpdate: (appointmentSelected || []).some(
              (item: any) => item.en === enApp,
            ),
          },
        ]
      : appointmentSelected,
  });
};

export const HandleSubmissions: Handler = async (controller, params) => {
  let apiToken = controller.state.apiToken;
  const dateTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";
  const today = moment().startOf("day");
  const start = today.clone().subtract(4, "days").startOf("day");
  const end = today.clone().add(3, "days").endOf("day");

  controller.setState({
    loadingStatus: true,
  });

  const [res] = await FastAPIRequestView.get({
    token: apiToken,
    endpoint: `/pre-verification/insurance/submissions`,
    params: {
      filter_start_dt: start.format(dateTimeFormat),
      filter_end_dt: end.format(dateTimeFormat),
    },
  });

  controller.setState({
    submissionsList: res?.data || [],
    loadingStatus: false,
  });
};

export const HandleGetInsuranceList: Handler = async (controller, params) => {
  let state = controller.getState();
  const buCode = state.selectedHospital?.code;
  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  const [result] = await FastAPIRequestView.post({
    token: state.apiToken,
    endpoint: "/pre-verification/insurance/available-list",
    data: {
      bu_code: buCode,
      insurance_type: "local_insurance",
      visit_type: "opd",
      is_broker: false,
    },
  });

  console.log("Debug ~ result:", result);

  controller.setState({
    insuranceList: result?.data || [],
    loadingStatus: { ...state.loadingStatus, [params.card]: false },
  });
};

export const HandleNewCardInsurance: Handler = async (controller, params) => {
  let state = controller.getState();
  let insuranceData: InsuranceDataFormatType = {
    dataSubmissions: {
      ...DEFAULT_INSURANCE_DATA_SUBMISSION,
      insurance_code: params.insuranceItem.insurance_code || "",
      bu_code: state.selectedHospital?.code || "",
      hospital_name: state.selectedHospital?.name || "",
      hn: state.selectedHospital?.hn || "",
    },
    insuranceSelected: params.newCard
      ? undefined
      : {
          ...params.insuranceItem,
          ...(params.insuranceItem.insurance_name_shot_name && {
            insurance_short_name: params.insuranceItem.insurance_name_shot_name,
          }),
        },
    expand: false,
    cardSelected: false,
    isActive: false,
    cardType: "newcard",
    en: state.appointmentSelected?.[0]?.encounter_number || "",
    id: `pre-verification-dummy`,
  };

  const filterDuplicate = state.cardInsuranceList.filter(
    (item: InsuranceDataFormatType) =>
      !item.id?.includes(`pre-verification-dummy`),
  );

  if (params.newCard) {
    controller.setState({
      cardInsuranceList: [...filterDuplicate, insuranceData],
    });

    return;
  }

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  const [result] = await HandleGetInsuranceDetail(controller, {
    insurance_code: params.insuranceItem.insurance_code,
    is_api: params.insuranceItem.is_api,
  });

  console.log("Debug ~ result:", result);

  if (result.data) {
    const insuranceDetail = {
      ...result.data,
      claim_groups: (result.data.claim_groups || []).map((item: any) => ({
        ...item,
        text: getTextByLanguage(item?.text, state.language),
      })),
      claim_types: (result.data?.claim_types || []).map((item: any) => ({
        ...item,
        text: getTextByLanguage(item.text, state.language),
      })),
    };

    controller.setState({
      cardInsuranceList: [
        ...filterDuplicate,
        {
          ...insuranceData,
          insuranceSelected: {
            ...insuranceData.insuranceSelected,
            ...insuranceDetail,
          },
        },
      ],
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  }
};

const getTextByLanguage = (
  text: string,
  language: "en-US" | "th-TH",
): string => {
  const splitText = text?.split("|");
  return language === "th-TH"
    ? splitText[1].trim() || ""
    : splitText[0].trim() || "";
};

const HandlePrepareCardData: Handler = async (controller, params) => {
  let state = controller.getState();
  const cardTypeCanCheckLang = ["Group", "Individual"];
  const buCode = state.selectedHospital?.code;
  const hn = state.selectedHospital?.hn;

  let insuranceListCode: string[] = [];
  if (params.lastVisitRes) {
    params.lastVisitRes.forEach((item: any) => {
      if (item.insurance_code) {
        insuranceListCode.push(
          `${item.insurance_code}-${item.is_api}-${item.is_broker}`,
        );
      }
    });
  }

  const enlist = (params?.appointment || []).map(
    (item: any) => item.encounter_number,
  );
  console.log("Debug ~ HandlePrepareCadeData ~ enlist:", enlist);

  if (params.submissionsRes) {
    params.submissionsRes
      .filter((item: any) => enlist.includes(item?.en))
      .forEach((item: any) => {
        if (item.original_payload.insurance_code) {
          insuranceListCode.push(
            `${item.original_payload.insurance_code}-${
              item.original_payload.is_api
                ? item.original_payload.is_api
                : "false"
            }-${item.is_broker}`,
          );
        }
      });
  }

  // ดึงข้อมูล dropdown ของแต่ละ insurance
  const uniqueInsuranceList: string[] = Array.from(new Set(insuranceListCode));
  const apiList = (uniqueInsuranceList || []).map((item: string) => {
    const splitItem = item.split("-");
    return HandleGetInsuranceDetail(controller, {
      insurance_code: splitItem[0],
      is_api: splitItem?.[1] === "true" ? true : false,
      is_broker: splitItem?.[2] === "true" ? true : false,
    });
  });

  const insuranceDetail = await Promise.all(apiList);

  const optionList = (insuranceDetail || [])
    .map((Item: any) => {
      return Item[0]?.insurance_code ? { ...Item[0] } : {};
    })
    .map((items: any) => {
      return {
        ...items,
        data: {
          ...items?.data,
          claim_groups: (items?.data?.claim_groups || []).map((item: any) => ({
            ...item,
            text: getTextByLanguage(item?.text, state.language),
          })),
          claim_types: (items?.data?.claim_types || []).map((item: any) => ({
            ...item,
            text: getTextByLanguage(item.text, state.language),
          })),
        },
      };
    });
  console.log("Debug ~ HandlePrepareCadeData ~ optionList:", optionList);

  const LastVisitList: InsuranceDataFormatType = (
    params.lastVisitRes || []
  ).map((items: any, index: any) => {
    const optionItem = optionList.find(
      (itemDetail: any) =>
        `${itemDetail.insurance_code}-${itemDetail.is_api}` ===
        `${items.insurance_code}-${items.is_api}`,
    );
    const insuranceItem = params.availableListRes.find(
      (itemDetail: any) =>
        `${itemDetail.insurance_code}-${itemDetail.is_api}` ===
        `${items.insurance_code}-${items.is_api}`,
    );

    const checkCommonType = cardTypeCanCheckLang.includes(
      items.insurance_type?.[0] || "",
    );

    return {
      dataSubmissions: {
        ...DEFAULT_INSURANCE_DATA_SUBMISSION,
        insurance_code: items.insurance_code,
        bu_code: buCode || "",
        hospital_name: state.selectedHospital?.name || "",
        hn: state.selectedHospital?.hn || "",
        insured_type_name: checkCommonType ? items.insurance_type?.[0] : "",
        claim_group: "",
        claim_type: "",
        remark: `lastVisit-${items.insurance_code}`,
        ...(items.is_broker && { is_broker: items.is_broker }),
      },
      insuranceSelected: {
        ...insuranceItem,
        ...(optionItem?.data && { ...optionItem?.data }),
        ...(insuranceItem?.insurance_name_shot_name && {
          insurance_short_name: insuranceItem.insurance_name_shot_name,
        }),
        insurance_short_name: items.insurance_short_name,
      },
      expand: false,
      cardSelected: false,
      isActive: true,
      cardType: "lastvisit",
      id: `lastVisit-${items.insurance_code}-${index + 1}`,
    };
  });

  const submissionsList: InsuranceDataFormatType = (params.submissionsRes || [])
    .filter(
      (item: any) =>
        enlist.includes(item?.en) || item.status === "Cancelled_with_hold",
    )
    .filter((item: any) => {
      return item.status === "Cancelled_with_hold"
        ? moment(item.original_payload.appointment_date)
            .endOf("day")
            .isSameOrAfter(moment().endOf("day"))
        : true;
    })
    .filter((item: any) => !["Cancelled", "undefined"].includes(item.status))
    .map((items: any, index: any) => {
      const optionItem = optionList.find((itemDetail: any) =>
        items.original_payload.is_api
          ? `${itemDetail.insurance_code}-${itemDetail.is_api}` ===
            `${items.original_payload.insurance_code}-${items.original_payload.is_api}`
          : itemDetail.insurance_code === items.original_payload.insurance_code,
      );
      const insuranceItem = params.availableListRes.find((itemDetail: any) =>
        items.original_payload.is_api
          ? `${itemDetail.insurance_code}-${itemDetail.is_api}` ===
            `${items.original_payload.insurance_code}-${items.original_payload.is_api}`
          : itemDetail.insurance_code === items.original_payload.insurance_code,
      );
      return {
        ...items,
        dataSubmissions: items.original_payload,
        insuranceSelected: {
          ...insuranceItem,
          ...(optionItem?.data && { ...optionItem?.data }),
          ...(insuranceItem?.insurance_name_shot_name && {
            insurance_short_name: insuranceItem.insurance_name_shot_name,
          }),
        },
        expand: false,
        cardSelected: true,
        isActive: true,
        cardType: "submit",
        id: `submissions-${items.original_payload.insurance_code}-${index + 1}`,
      };
    });

  return [LastVisitList, submissionsList];
};

export const HandleGetInsuranceDetail: Handler = async (controller, params) => {
  let state = controller.getState();

  return await FastAPIRequestView.post({
    // bearer: controller.cookies.get("bearer"),
    token: state.apiToken,
    endpoint: "/pre-verification/insurance/dropdown-options",
    data: {
      bu_code: state.selectedHospital?.code || "",
      insurance_type: "local_insurance",
      visit_type: "opd",
      is_broker: params.is_broker ?? false,
      is_api: params.is_api,
      insurance_code: params.insurance_code,
    },
  });
};

export const HandleGetStatusMenu: Handler = async (controller, params) => {
  let state = controller.getState();

  const [resUserPerMiss, resUnreadNoti] = await Promise.all([
    UserPermissionView.post({
      apiToken: state.apiToken,
      data: { config_PRX_PRE_VERIFICATION_CONFIG: "" },
    }),
    FastAPIRequestView.get({
      bearer: controller.cookies.get("bearer"),
      endpoint: "/insurance/list_unread_noti/",
    }),
  ]);

  controller.setState({
    notiPendingInsurance: resUnreadNoti?.[0]?.data || [],
    menuItemStatus: resUserPerMiss?.[0]
      ? JSON.parse(resUserPerMiss?.[0]?.config_PRX_PRE_VERIFICATION_CONFIG) ||
        []
      : [],
    loadingStatus: { ...state.loadingStatus, [params.card]: "SUCCESS" },
  });
};

export const HandleSubmissionForm: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  const dataHaveSignature = state.cardInsuranceList
    .filter(
      (item: InsuranceDataFormatType) =>
        item.cardSelected && item.cardType != "submit",
    )
    .map((item: InsuranceDataFormatType) => {
      const itemData = item;

      /// เคส ที่ไม่ใช่ ACCIDENT
      if (
        !itemData["dataSubmissions"]["claim_group"]
          ?.toLocaleLowerCase()
          .includes("ACCIDENT".toLocaleLowerCase())
      ) {
        const claimGroupSelected = (
          item.insuranceSelected?.claim_groups || []
        ).find(
          (claimGroupItem: any) =>
            claimGroupItem.value === itemData["dataSubmissions"]["claim_group"],
        );

        const claimTypeSelected = (
          item.insuranceSelected?.claim_types || []
        ).filter(
          (claimTypeItem: any) =>
            claimTypeItem.claim_group ===
            itemData["dataSubmissions"]["claim_group"],
        );

        itemData["dataSubmissions"]["claim_type"] =
          claimTypeSelected[0]?.value ||
          itemData["dataSubmissions"]["claim_group"];
        itemData["dataSubmissions"]["is_accident"] = false;
        itemData["dataSubmissions"]["accident_datetime"] =
          state.appointmentSelected.date;
      }

      /// เคส ที่เป็น ACCIDENT
      if (
        itemData["dataSubmissions"]["claim_group"]
          ?.toLocaleLowerCase()
          .includes("ACCIDENT".toLocaleLowerCase())
      ) {
        itemData["dataSubmissions"]["is_accident"] = true;
      }

      /// เคส ที่ไม่เป็น HEALTH_CHECKUP
      if (
        !itemData["dataSubmissions"]["claim_group"]
          ?.toLocaleLowerCase()
          .includes("HEALTH_CHECKUP".toLocaleLowerCase())
      ) {
        itemData["dataSubmissions"]["voucher"] = undefined;
      }

      /// เคส ที่เป็น HEALTH CHECKUP
      if (
        itemData["dataSubmissions"]["claim_group"]
          ?.toLocaleLowerCase()
          .includes("HEALTH_CHECKUP".toLocaleLowerCase())
      ) {
        itemData["dataSubmissions"]["symptoms"] = "-";
        if (itemData["dataSubmissions"]["voucher"] === "") {
          itemData["dataSubmissions"]["voucher"] = "-";
        }
      }

      itemData["dataSubmissions"]["signature_data"] = params.signatureBase64;
      itemData["dataSubmissions"]["visit_date"] = params.signatureBase64;
      return itemData;
    });

  const apiArray = dataHaveSignature.flatMap((item: InsuranceDataFormatType) =>
    state.appointmentSelected.map((appItem: any) =>
      params.isEnableIMS
        ? FastAPIRequestView.post({
            token: state.apiToken,
            endpoint: "/pre-verification/insurance/submit-form",
            data: {
              ...item.dataSubmissions,
              remark: `${item.dataSubmissions.remark}-${appItem.encounter_number}`,
              episode_no: appItem.encounter_number,
              appointment_date: appItem.date,
              visit_date: appItem.date,
              insurer_display: item.insuranceSelected?.insurance_name_th,
              is_ims_insurance: item.insuranceSelected?.is_ims_insurance,
              is_api: item.insuranceSelected?.is_api,
              location: [appItem?.division_name || "-"],
              encounter_row_id: appItem?.encounter_number || "",
            },
          })
        : SmartInsuranceSendMail.create({
            apiToken: state.apiToken,
            data: {
              hospital_id: state.selectedHospital?.code || "",
              hn: state.selectedHospital?.hn || "",
              en: appItem.encounter_number || "",
              appointment_datetime: appItem.date,
              division: appItem.division || "",
              visit_type: "opd",
              symptoms: item.dataSubmissions?.symptoms || "",
              accident_datetime:
                item.dataSubmissions?.accident_datetime || appItem.date,
              insurance_code: item.dataSubmissions?.insurance_code || "",
              insurance_name_th:
                item.insuranceSelected?.insurance_name_th || "",
              insured_type_name: item.dataSubmissions.insured_type_name || "",
              claim_group: item.dataSubmissions.claim_group || "",
              claim_type: item.dataSubmissions.claim_type || "",
              voucher: item.dataSubmissions?.voucher || "",
              insurance_card: item.dataSubmissions?.insurance_card_copy || "-",
            },
          }),
    ),
  );

  const promise = await Promise.all(apiArray);
  if (promise.some((item: any) => !!item[0])) {
    controller.setState({
      submitStatus: "success",
      preverUiMode: "unknow",
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  } else {
    controller.setState({
      submitStatus: "error",
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  }
};

export const HandleCancelSubmit: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: "LOADING" },
  });

  const appDateISO = moment(state.appointmentSelected?.[0].date, ISO_8601);
  const [res] = await FastAPIRequestView.put({
    token: state.apiToken,
    endpoint: `/pre-verification/insurance/submissions/${params.docId}/cancel`,
    data: {
      cancel_reason: params.reason,
      cancel_reason_code: params.reasonCode,
      appointment_date: appDateISO.isValid()
        ? appDateISO.toISOString()
        : state.appointmentSelected?.[0].date,
    },
  });

  if (res) {
    controller.setState({
      preverUiMode: "unknow",
      loadingStatus: { ...state.loadingStatus, [params.card]: "SUCCESS" },
    });
  } else {
    controller.setState({
      loadingStatus: { ...state.loadingStatus, [params.card]: undefined },
    });
  }
};

export const HandleGetPerVerificationStatus: Handler = async (
  controller,
  params,
) => {
  let state = controller.getState();
  const buCode = state.selectedHospital?.code;
  const hn = state.selectedHospital?.hn;
  controller.setState({
    loadingStatus: { ...state.loadingStatus, [params.card]: true },
  });

  const [docRes, DetailRes] = await Promise.all([
    FastAPIRequestView.get({
      // bearer: controller.cookies.get("bearer"),
      token: state.apiToken,
      endpoint: `/pre-verification/insurance/submissions/${params.docId}`,
    }),
    FastAPIRequestView.post({
      // bearer: controller.cookies.get("bearer"),
      token: state.apiToken,
      endpoint: `/pre-verification/insurance/reservation-detail`,
      data: {
        bu_code: buCode,
        hn: hn,
        en: params.en,
      },
    }),
  ]);

  if (docRes?.[0] || DetailRes?.[0]) {
    controller.setState({
      preVerificationStatusDetail: {
        ...docRes[0],
        reservationDetail: DetailRes?.[0]?.data || [],
      },
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  } else {
    controller.setState({
      preVerificationStatusDetail: undefined,
      loadingStatus: { ...state.loadingStatus, [params.card]: false },
    });
  }
};

export const GetOrganizationDetail: Handler = async (controller, params) => {
  const state = controller.getState();

  const [res] = await ProxyOrganizationView.list({
    apiToken: controller.cookies.get("apiToken"),
    params: {
      code: state.selectedHospital?.code,
    },
  });

  controller.setState({ organizationDetail: res?.items?.[0] || {} });
};

export const getDatesWithinNext3Days = (list: any) => {
  const today = moment().startOf("day");
  const end = today.clone().add(3, "days").endOf("day");

  let appointmentInPeriod = (list || []).filter((item: any) => {
    const itemMoment = moment(item.date);
    return itemMoment.isBetween(today, end, undefined, "[]");
  });

  if (!(appointmentInPeriod || []).length) return [];

  const inListHaveEn = (appointmentInPeriod || []).some(
    (item: any) => item.encounter_number,
  );

  if (inListHaveEn) {
    appointmentInPeriod = (appointmentInPeriod || []).filter(
      (item: any) => item.encounter_number,
    );
  }

  const firstDay = moment(appointmentInPeriod[0]?.date).format("YYYY-MM-DD");

  const findByDate = (appointmentInPeriod || []).filter(
    (item: any) => moment(item.date).format("YYYY-MM-DD") === firstDay,
  );
  console.log("Debug ~ getDatesWithinNext3Days ~ findByDate:", findByDate);
  const seen = new Set<string>();

  // เลือกเฉพาะอันที่ encounter_number ไม่ซ้ำกัน และเอาทุก appointment ที่อยู่วันเดียวกัน
  return findByDate.filter((item: any) => {
    if (seen.has(item.encounter_number)) return false;
    seen.add(item.encounter_number);
    return true;
  });
};

export const getDatesWithinNext3DaysIgnoreEn = (list: any) => {
  const today = moment().startOf("day");
  const end = today.clone().add(3, "days").endOf("day");

  let appointmentInPeriod = (list || []).filter((item: any) => {
    const itemMoment = moment(item.date);
    return itemMoment.isBetween(today, end, undefined, "[]");
  });

  if (!(appointmentInPeriod || []).length) return [];

  const firstDay = moment(appointmentInPeriod[0]?.date).format("YYYY-MM-DD");

  const findByDate = (appointmentInPeriod || []).filter(
    (item: any) => moment(item.date).format("YYYY-MM-DD") === firstDay,
  );

  // เลือกเฉพาะอันที่ encounter_number ไม่ซ้ำกัน และเอาทุก appointment ที่อยู่วันเดียวกัน
  return findByDate
};

const mockEstimator = [
  {
    Result: {
      Code: "S",
      Message: "success",
      MessageTh: "ทำรายการสำเร็จ",
    },
    Data: {
      RefId: "2aff04ef-9b53-4708-830d-df4ea6f7bc5c",
      TransactionNo: "abf5002f-7832-4b02-8e0a-658f73656774",
      InsurerCode: "13",
      PolicyType: "IB",
      PackageCode: "01PRO2430933T_11630",
      PresentedPrice: 145000,
      OutOfPocket: 75300,
      Title: {
        Th: "Laser Haemorrhoidectomy",
        En: "Laser Haemorrhoidectomy",
      },
      Url: {
        Th: "https://www.bangkokhospital.com/contact/",
        En: "https://www.bangkokhospital.com/en/contact/",
      },
      RemarkList: [
        {
          Th: null,
          En: null,
        },
      ],
      AlternativeList: [],
    },
  },
  {
    Result: {
      Code: "F",
      Message: "failed",
      MessageTh: "ทำรายการสำเร็จ",
    },
    Data: {
      RefId: "2aff04ef-9b53-4708-830d-df4ea6f7bc5c",
      TransactionNo: "abf5002f-7832-4b02-8e0a-658f73656774",
      InsurerCode: "13",
      PolicyType: "CS ",
      PackageCode: "01PRO2430933T_11630",
      PresentedPrice: 145000,
      OutOfPocket: 75300,
      Title: {
        Th: "Laser Haemorrhoidectomy",
        En: "Laser Haemorrhoidectomy",
      },
      Url: {
        Th: "https://www.bangkokhospital.com/contact/",
        En: "https://www.bangkokhospital.com/en/contact/",
      },
      RemarkList: [
        {
          Th: null,
          En: null,
        },
      ],
      AlternativeList: [],
    },
  },
];

export const DEFAULT_INSURANCE_DATA_SUBMISSION: InsuranceDataSubmissionsType = {
  bu_code: 0,
  hospital_name: "",
  is_accident: false,
  accident_datetime: "",
  episode_no: "",
  insurance_code: "",
  appointment_date: "",
  visit_date: "",
  hn: "",
  signature_data: "",
  insured_type_name: "",
  claim_group: "",
  claim_type: "",
  symptoms: "",
  voucher: "",
  remark: "",
  is_broker: false,
};
